import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import createAnalyticsApi from 'api/analytics';
import { appContextSelector } from 'modules/app/appSlice';
import { powerBiReportIdSelector } from 'modules/user/userSlice';
import { AppThunk } from 'store';

interface State {
  config?: EmbedConfig;
  isLoading: boolean;
}

const initialState: State = {
  isLoading: false,
};

const slice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setLoading: (state: State, action: PayloadAction<boolean>): State => {
      state.isLoading = action.payload;
      return state;
    },
    setConfig: (state: State, action: PayloadAction<EmbedConfig>): State => {
      state.config = action.payload;
      return state;
    },
  },
});

const { setLoading, setConfig } = slice.actions;

export default slice.reducer;

export const loadPowerBiEmbedConfig = (): AppThunk => async (dispatch, getState): Promise<void> => {
  // eslint-disable-next-line no-undef
  const reportId = powerBiReportIdSelector(getState()) ?? '';
  const partnershipId = getState().user?.currentAccount?.partnershipId ?? '';
  const context = appContextSelector(getState());
  const analyticsApi = createAnalyticsApi(context);

  dispatch(setLoading(true));
  try {
    const result = await analyticsApi.getEmbedConfig(reportId, partnershipId);
    dispatch(setConfig(result));
    dispatch(setLoading(false));
  } catch {
    dispatch(setLoading(false));
  }
};
